/**
 * Has this browser been here before? Judged from the marks earlier
 * visits leave behind (the release store's visited date, the cookie
 * answer, the home page's seen flag, the install sheet's dismissal),
 * read ONCE when the chunk loads, before any effect of this visit has
 * written a mark of its own. A fresh device, private mode or disabled
 * storage all read as a first visit, which is the right failure: the
 * guidance shows one time too many rather than never.
 */
const PRIOR_VISIT_KEYS = [
  "menzil.visited",
  "menzil-cookie-consent",
  "menzil_home_seen",
  "menzil-install-firstvisit-dismissed",
];

function compute(): boolean {
  try {
    return PRIOR_VISIT_KEYS.some((k) => window.localStorage.getItem(k) !== null);
  } catch {
    return false;
  }
}

const atLoad: boolean | null = typeof window !== "undefined" ? compute() : null;

/** True when earlier visits left a mark on this device. */
export function returningDevice(): boolean {
  return atLoad ?? compute();
}
